<script>
import { loadStripe } from '@stripe/stripe-js';

export default {
  props: ['item'],
  data() {
    return {
      dsbl_btn: false,

      stripe: {},
      // cardElement: {},
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},

      loading: false,
    }
  },
  computed: {

  },
  async mounted() {
    this.stripe = await loadStripe(process.env.MIX_STRIPE_KEY);
    const elements = this.stripe.elements();

    // this.cardElement = elements.create('card');
    // this.cardElement.mount('#card-element');

    this.cardNumber = elements.create('cardNumber');
    this.cardNumber.mount('#card-number');

    this.cardExpiry = elements.create('cardExpiry');
    this.cardExpiry.mount('#card-expiry');

    this.cardCvc = elements.create('cardCvc');
    this.cardCvc.mount('#card-cvc');
  },
  created() {

  },
  methods: {
    quantity_change(serv, serv_i) {
      this.item.cart.services[serv_i].quantity = Math.round(this.item.cart.services[serv_i].quantity);
      if(serv.quantity < 1) {
        if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
        var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
        var removed = false;
        var n = new Noty({
          timeout: false,
          modal: true,
          type: 'alert', // alert, success, warning, error, info
          layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
          closeWith: ['button'], // click, button
          text: "Remove this item from the cart?",
          buttons: [
            Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
              var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
              if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
              this.item.cart.services.splice(serv_i, 1);
              removed = true;
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }, {id: randomid, 'data-status': 'ok'}),
            Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
              this.item.cart.services[serv_i].quantity = 1;
              n.close();
            }, {id: randomid+'_no', 'data-status': 'ok'}),
          ]
        }).show().on('onClose', () => { if(!removed) { this.item.cart.services[serv_i].quantity = 1; } this.dsbl_btn = false; });
      }
      if(serv.quantity > 99) { this.item.cart.services[serv_i].quantity = 99; }
    },
    async submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;

      // =======================
      if(
        !this.item.PropertyType ||
        !this.item.PropertySubType ||
        !this.item.CountyOrParish ||
        !this.item.StreetNumber ||
        !this.item.StreetName ||
        !this.item.City ||
        !this.item.StateOrProvince ||
        !this.item.PostalCode
      ) {
        this.$noty.error("The property address section is missing some required information. Please return to the property address tab to resolve this issue.");
        this.loading = false; return;
      }
      // =======================
      if(
        !this.item.ListPrice
      ) {
        this.$noty.error("The list price section is missing some required information. Please return to the list price tab to resolve this issue.");
        this.loading = false; return;
      }
      // =======================
      if(
        Object.keys(this.item.cart.package).length === 0
      ) {
        this.$noty.error("A package is required. Please return to the packages and services tab to resolve this issue.");
        this.loading = false; return;
      }
      // =======================
      if(
        !this.item.MailingAddress ||
        !this.item.MailingCity ||
        !this.item.MailingStateOrProvince ||
        !this.item.MailingPostalCode ||
        !this.item.OwnerName ||
        !this.item.OwnerEmail ||
        !this.item.OwnerPhone ||
        !this.item.sign_company.occupancy ||
        !this.item.sign_company.dogs ||
        !this.item.sign_company.property_access ||
        (this.item.sign_company.property_access == 'Other' && !this.item.sign_company.property_access_other) ||
        !this.item.sign_company.schedule_date ||
        !this.item.sign_company.schedule_time ||
        !this.item.sign_company.schedule_preference ||
        !this.item.is_realtor ||
        !this.item.buying ||
        !this.item.has_realtor ||
        !this.item.referred_by ||
        (this.item.referred_by == 'referral' && !this.item.referred_name)
      ) {
        this.$noty.error("The additional details section is missing some required information. Please return to the additional details tab to resolve this issue.");
        this.loading = false; return;
      }
      // =======================
      if(this.item.estimated_total > 0) {
        if(
          !this.item.cart.to_name ||
          !this.item.cart.to_address ||
          !this.item.cart.to_city ||
          !this.item.cart.to_state ||
          !this.item.cart.to_zip_code
        ) {
          this.$noty.error("The billing address section is missing some required information.");
          this.loading = false; return;
        }
      }
      
      // =======================
      if(
        !this.item.agree_terms ||
        !this.item.not_refundable ||
        (!this.item.agree_cancellation && this.item.estimated_total == 0)
      ) {
        this.$noty.error("Before continuing you must agree to our listing agreements.");
        this.loading = false; return;
      }

      if(this.item.estimated_total > 0) {
        const {paymentMethod, error} = await this.stripe.createPaymentMethod('card', this.cardNumber, {
          billing_details: {
            name: this.item.cart.to_name,
            email: this.user.email,
            phone: this.user.phone,
            address: {
              line1: this.item.cart.to_address,
              city: this.item.cart.to_city,
              state: this.item.cart.to_state,
              postal_code: this.item.cart.to_zip_code
            }
          }
        });
        if(error) {
          console.log(error);
          if(error.message) { this.$noty.error(error.message); }
          else { this.$noty.error(error); }
          this.loading = false;
          return;
        }
        this.item.payment_method_id = paymentMethod.id;
      }
      this.$http.post('/listings/store', this.item).then(res => {
        // console.log(res);
        this.item.id = res.data.id;
        this.item.StandardStatus = res.data.StandardStatus;
        this.item.packages_total = res.data.packages_total;
        this.item.estimated_total = res.data.estimated_total;
        this.item.active_package = res.data.active_package;
        this.item.active_services = res.data.active_services;
        this.item.cart = {package:{}, services:[]}
        this.item.user = res.data.user;
        this.item.carts = res.data.carts;

        if(this.item.id) {
          history.pushState({}, null, '/my-listings/'+this.item.id);
          this.$emit('setpage', 7);
          this.loading = false;
        } else {
          this.$emit('setpage', 'failedorder'); this.loading = false; return;
        }
      }).catch(res => { console.log(res); this.popupErrors(res); this.loading = false; });
    },
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Submit your listing.png')" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Submit your listing</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Please take a minute to review the information you have entered so far. If you need to make changes, you are free to go back to previous sections and update your information.</p>
      </div>

      <div class="border rounded p-3 mb-3">
        <a class="float-right text-primary _c-pointer" @click="$emit('setpage', 2)">Edit</a>
        <h5 class="m-0">Property Type:</h5>
        <p class="text-gray-700 mb-3">{{item.PropertyType}}</p>
        <h5 class="m-0">Property Sub Type:</h5>
        <p class="text-gray-700 mb-3">{{item.PropertySubType}}</p>
        <h5 class="m-0">County/Parish:</h5>
        <p class="text-gray-700 mb-3">{{item.CountyOrParish}}</p>
        <h5 class="m-0">Property address:</h5>
        <p class="text-gray-700">{{item.Address}} {{item.City}} {{item.StateOrProvince}} {{item.PostalCode}}</p>
      </div>
      <div class="border rounded p-3 mb-3">
        <a class="float-right text-primary _c-pointer" @click="$emit('setpage', 3)">Edit</a>
        <h5 class="m-0">List price:</h5>
        <p class="text-gray-700">{{formatPrice(item.ListPrice, true, false)}}</p>
      </div>
      <div class="border rounded p-3 mb-3">
        <a class="float-right text-primary _c-pointer" @click="$emit('setpage', 5)">Edit</a>
        <h5 class="m-0">Mailing address:</h5>
        <p class="text-gray-700 mb-3">{{item.MailingAddress}} {{item.MailingCity}} {{item.MailingStateOrProvince}} {{item.MailingPostalCode}}</p>
        <h5 class="m-0">Owner:</h5>
        <p class="text-gray-700 mb-3">{{item.OwnerName}} / {{item.OwnerEmail}} / {{formatPhone(item.OwnerPhone)}}</p>
        <h5 class="m-0">Additional Owners:</h5>
        <p class="text-gray-700" v-for="(owner, owner_i) in item.Owners" :key="owner_i">{{owner.name}} / {{owner.email}} / {{formatPhone(owner.phone)}}</p>
        <h5 class="m-0">Property occupied by:</h5>
        <p class="text-gray-700 mb-3">{{item.sign_company.occupancy}}</p>
        <h5 class="m-0">Are dogs present?</h5>
        <p class="text-gray-700 mb-3">{{item.sign_company.dogs}}</p>
        <h5 class="m-0">How will the property be accessed?</h5>
        <p class="text-gray-700 mb-3">{{item.sign_company.property_access}} <span v-if="item.sign_company.property_access == 'Other'">({{item.sign_company.property_access_other}})</span></p>
        <h5 class="m-0">Desired Date of Service?</h5>
        <p class="text-gray-700 mb-3">{{moment(item.sign_company.schedule_date).format('MM-DD-YYYY')}}</p>
        <h5 class="m-0">Desired Time of Service?</h5>
        <p class="text-gray-700 mb-3">{{item.sign_company.schedule_time}}</p>
        <h5 class="m-0">Which is more important to you?</h5>
        <p class="text-gray-700 mb-3">{{item.sign_company.schedule_preference}}</p>
        <h5 class="m-0">Licensed realtor in property region?</h5>
        <p class="text-gray-700 mb-3">{{item.is_realtor}}</p>
        <h5 class="m-0">Looking to buy a property?</h5>
        <p class="text-gray-700 mb-3">{{item.buying}}</p>
        <h5 class="m-0">Are you currently working with a realtor?</h5>
        <p class="text-gray-700 mb-3">{{item.has_realtor}}</p>
        <h5 class="m-0">How did you hear about us?</h5>
        <p v-if="item.referred_by == 'phone call'" class="text-gray-700">Phone Call</p>
        <p v-else-if="item.referred_by == 'text message'" class="text-gray-700">Text Message</p>
        <p v-else-if="item.referred_by == 'television ad'" class="text-gray-700">Television Ad</p>
        <p v-else-if="item.referred_by == 'radio ad'" class="text-gray-700">Radio Ad</p>
        <p v-else-if="item.referred_by == 'internet ad'" class="text-gray-700">Internet Ad</p>
        <p v-else-if="item.referred_by == 'facebook'" class="text-gray-700">Facebook</p>
        <p v-else-if="item.referred_by == 'instagram'" class="text-gray-700">Instagram</p>
        <p v-else-if="item.referred_by == 'event'" class="text-gray-700">Event</p>
        <p v-else-if="item.referred_by == 'mail brochure'" class="text-gray-700">Mail - Brochure</p>
        <p v-else-if="item.referred_by == 'mail postcard'" class="text-gray-700">Mail - Postcard</p>
        <p v-else-if="item.referred_by == 'referral'" class="text-gray-700">Referral from another client ({{item.referred_name}})</p>
        <p v-else-if="item.referred_by == 'repeat client'" class="text-gray-700">Repeat Client</p>
        <p v-else class="text-gray-700">None</p>
      </div>
      
      <div class="border rounded p-3 mb-3">
        <a class="float-right text-primary _c-pointer" @click="$emit('setpage', 4)">Edit</a>
        <h5 class="mb-3">Packages and services</h5>
        <div class="table-responsive">
          <table class="table small m-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th style="width: 10%">Quantity</th>
                <th style="width: 10%" class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="Object.keys(item.cart.package).length > 0">
                <td>1</td>
                <td>
                  <b>{{item.cart.package.title}} Package</b> <br>
                  <p v-for="(pack, pack_i) in item.cart.package.services" :key="'a'+pack_i" class="text-gray-700 m-0">{{pack.title}}</p>
                </td>
                <td>1</td>
                <td class="text-right">{{formatPrice(item.cart.package.price)}}</td>
              </tr>
              <tr v-for="(serv, serv_i) in item.cart.services" :key="'b'+serv.id">
                <td>{{serv_i+(item.cart.package ? 2 : 1)}}</td>
                <td><b>{{serv.title}}</b></td>
                <td v-if="!serv.once" class="p-1 align-middle">
                  <input type="number" class="form-control py-0 px-2 _h-30" v-model="serv.quantity" min="0" max="99" @change="quantity_change(serv, serv_i)">
                </td>
                <td v-else class="align-middle">{{serv.quantity}}</td>
                <td class="text-right">{{formatPrice(serv.price * serv.quantity)}}</td>
              </tr>
              <tr>
                <td class="text-right h5 pt-5 font-weight-bold" colspan="4">Cart total:<span class="text-success ml-2">{{formatPrice(item.estimated_total)}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-show="item.estimated_total > 0" class="border rounded p-3 mb-3">
        <div class="row">
          <div class="col-sm _w-m-250 border-right border-light">
            <h5 class="mb-3">Enter payment information</h5>
            <small class="text-muted">Processed securely through <a href="https://stripe.com/" target="_blank">Stripe</a>.</small>
            <img src="/images/stripe-payment-logo.png" class="_w-m-150 mt-1">
          </div>
          <div class="col-sm">
            <!-- <div id="card-element" class="form-control" style="padding-top: 0.6rem !important"></div> -->
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="field-BillingName">Name on card <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                  <input id="field-BillingName" name="address" type="text" class="form-control" v-model="item.cart.to_name" required>
                  <small class="text-muted"></small>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="field-to_address">Billing address <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                  <input id="field-to_address" name="address" type="text" class="form-control" v-model="item.cart.to_address" required>
                  <small class="text-muted"></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="field-to_city">Billing city <span class="text-danger" v-tippy content="This field is required.">*</span> </label>
                  <input id="field-to_city" name="city" type="text" class="form-control" v-model="item.cart.to_city" required>
                  <small class="text-muted"></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="field-to_state">Billing state <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                  <select id="field-to_state" name="state" class="form-control" v-model="item.cart.to_state" required>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                  <small class="text-muted"></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="field-to_zip_code">Billing zip code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                  <input id="field-to_zip_code" name="zip_code" type="text" class="form-control" v-model="item.cart.to_zip_code" required>
                  <small class="text-muted"></small>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-12 mb-3">
                <label for="card_element" class="d-block">Card number <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                <div id="card-number" class="form-control" style="padding-top: 0.6rem !important"></div>
              </div>
              <div class="col-sm-6 mb-3">
                <label for="card_element" class="d-block">Expiration date <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                <div id="card-expiry" class="form-control" style="padding-top: 0.6rem !important"></div>
              </div>
              <div class="col-sm-6 mb-3">
                <label for="card_element" class="d-block">CVC code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                <div id="card-cvc" class="form-control" style="padding-top: 0.6rem !important"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded p-3 mb-3">
        <h5 class="mb-3">Listing agreements</h5>
        <div class="mb-2">
          <p-check class="p-default p-curve p-smooth" color="success" v-model="item.agree_terms" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I agree to {{app_name}}'s terms of service. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
        </div>
        <div class="mb-2">
          <p-check class="p-default p-curve p-smooth" color="success" v-model="item.not_refundable" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I understand that all sales are final and not refundable. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
        </div>
        <div v-if="item.cart.package && item.cart.package.price == 0">
          <p-check class="p-default p-curve p-smooth mb-1" color="success" v-model="item.agree_cancellation" required v-tippy content="The cancellation fee should be listed on the package details.">I understand that the {{item.cart.package.title}} package has a cancellation fee. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
        </div>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 5)" :disabled="loading || dsbl_btn"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading || dsbl_btn"><span class="spinner-border spinner-border-sm" v-show="loading"></span> {{loading ? 'Processing...' : item.estimated_total > 0 ? 'Submit payment' : 'Submit'}} <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
